/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentMenuContainerBackgroundColor = "#fff";
export const componentMenuContainerBorderRadius = "0.25rem";
export const componentMenuContainerElevation = "0 0.3125rem 0.625rem 0.1875rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.10)";
export const componentMenuContainerPaddingHorizontal = 0;
export const componentMenuContainerPaddingVertical = "0.5rem";
export const componentMenuContainerStateEnterOpacity = 0;
export const componentMenuContainerStateEnterPositionBottomTranslateY = "-0.5rem";
export const componentMenuContainerStateEnterPositionTopTranslateY = "0.5rem";
export const componentMenuContainerStateEnterActiveOpacity = 1;
export const componentMenuContainerStateEnterActiveTransition = "all 0.1s cubic-bezier(0.165, 0.84, 0.44, 1)";
export const componentMenuContainerStateEnterActiveTranslateY = 0;
export const componentMenuContainerStateExitOpacity = 1;
export const componentMenuContainerStateExitTranslateY = 0;
export const componentMenuContainerStateExitActiveOpacity = 0;
export const componentMenuContainerStateExitActivePositionBottomTranslateY = "-0.5rem";
export const componentMenuContainerStateExitActivePositionTopTranslateY = "0.5rem";
export const componentMenuContainerStateExitActiveTransition = "all 0.1s cubic-bezier(0.165, 0.84, 0.44, 1)";
export const componentMenuItemContainerAlignVertical = "center";
export const componentMenuItemContainerPaddingHorizontal = "1rem";
export const componentMenuItemContainerPaddingVertical = "0.5rem";
export const componentMenuItemLeadingIconIconColorDefault = "#000";
export const componentMenuItemLeadingIconIconColorHover = "#004f9a";
export const componentMenuItemLeadingIconIconColorFocus = "#004f9a";
export const componentMenuItemLeadingIconIconColorActive = "#002d58";
export const componentMenuItemLeadingIconIconSize = "small";
export const componentMenuItemLeadingIconMarginRight = "0.5rem";
export const componentMenuItemTextLabelFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentMenuItemTextLabelFontSize = "0.875rem";
export const componentMenuItemTextLabelLineHeight = "1.25rem";
export const componentMenuItemTextLabelTextColorDefault = "#2e2f32";
export const componentMenuItemTextLabelTextColorHover = "#004f9a";
export const componentMenuItemTextLabelTextColorFocus = "#004f9a";
export const componentMenuItemTextLabelTextColorActive = "#002d58";
export const componentMenuItemTextLabelTextDecorationDefault = "underline";
export const componentMenuItemTextLabelTextDecorationHover = "none";
export const componentMenuItemTextLabelTextDecorationFocus = "none";
export const componentMenuItemTextLabelTextDecorationActive = "none";
export const componentMenuItemTextLabelWhiteSpace = "nowrap";
export const componentMenuLayoutContainerPositionBottomLeftOffsetTop = "0.5rem";
export const componentMenuLayoutContainerPositionBottomRightOffsetTop = "0.5rem";
export const componentMenuLayoutContainerPositionTopLeftOffsetBottom = "0.5rem";
export const componentMenuLayoutContainerPositionTopRightOffsetBottom = "0.5rem";
export const componentMenuLayoutContainerZIndex = "300";